module.exports = __webpack_public_path__ + "media/images/pic/tree-e0a8ec5b57743bc374bfdab6f19a46ff.jpg";